export default "__VITE_ASSET__3vJ3k1aW__"